import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Mutation } from '@apollo/react-components';
import validator from 'validator';
import FormControl from '@mui/material/FormControl';
import { mutations } from '../graphql';
import StoreForm from './Forms/Store/StoreForm.js';
import StoreInput from './Forms/Store/StoreInput.js';
import FeedbackMessage from './FeedbackMessage.js';
import Captcha from './Captcha.js';
import { useTextTranslation } from '../Hooks';
import NiceError from './Errors/NiceError';

const SendResetPassword = ({ email, onMessageSent }) => {
  const [message, setMessage] = useState('');
  const [error, setError] = useState(null);
  // Turnstile key for the reset request. Sent as an OPTIONAL variable during the staged
  // rollout: the API verifies it when present and only requires it once
  // RESET_CAPTCHA_MODE=enforce is flipped server-side.
  const [captchaVerificationKey, setCaptchaVerificationKey] = useState('');

  const successText = useTextTranslation('email-sent-please-follow-instructions');

  const handleSubmitSuccess = () => {
    setMessage(successText);
    if (onMessageSent) {
      onMessageSent();
    }
  };

  const handleSubmitError = (err) => {
    setError(err);
  };

  const handleCaptchaError = (msg) => {
    setCaptchaVerificationKey('');
    setError(new Error(msg));
  };

  return (
    <>
      <FeedbackMessage message={message} type='success' height='5rem' />
      <NiceError err={error} defaultText='finding-your-account' />
      <FormControl margin='normal'>
        <Captcha
          action='reset'
          onSuccess={setCaptchaVerificationKey}
          onError={handleCaptchaError}
        />
      </FormControl>
      <Mutation
        mutation={mutations.ResetPassword}
      >
        {resetPassword => (
          <StoreForm
            fields={{ email: '' }}
            onSubmit={(options) => {
              setError(null);
              const variables = email ? { email } : options.variables;
              return resetPassword({
                ...options,
                variables: { ...variables, captchaVerificationKey }
              });
            }}
            onSubmitSuccess={handleSubmitSuccess}
            onSubmitError={handleSubmitError}
            submitLabel='send-reset-email'
          >
            {
              !email
                ? <StoreInput
                    id='email'
                    label='email-address'
                    autoFocus
                    required
                    maxLength={100}
                    validate={(val) => (validator.isEmail(val) ? '' : 'Invalid Email')}
                  />
                : null
            }
          </StoreForm>
        )}
      </Mutation>
    </>
  );
};

SendResetPassword.propTypes = {
  email: PropTypes.string,
  onMessageSent: PropTypes.func
};

export default SendResetPassword;
